import { Directive, HostListener, Input, NgModule } from "@angular/core";
import { InputNumber } from "primeng/inputnumber";

@Directive({
    selector: "p-inputNumber[customInputNumber]",
})
export class CustomInputNumberDirective {
    constructor(private host: InputNumber) {
    }
    @Input() selectAllOnFocus = false;
    @HostListener('onFocus') onFocus() {
        this.host.input.nativeElement.style.backgroundColor = "yellow";
        if(this.selectAllOnFocus){
            this.host.input.nativeElement.select();
        }
      }
    @HostListener('onBlur') onBlur() {
        this.host.input.nativeElement.style.backgroundColor = "white";
    }

}

@NgModule({
    imports: [
    ],
    declarations: [
        CustomInputNumberDirective,
    ],
    exports: [
        CustomInputNumberDirective,
    ]
})
export class CustomInputNumberModule {

}